// extracted by mini-css-extract-plugin
module.exports = {"top":"SQ","bottom":"TQ","new":"UQ","styleRoom":"VQ","isTrusted":"WQ","productLink":"XQ","details":"YQ","mainText":"ZQ","subText":"_Q","colorName":"aR","storeWrapper":"bR"};